import {
  BalanceType,
  GetPatientsBalanceResponse_PatientBalance,
} from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';

export const searchByText = (data: GetPatientsBalanceResponse_PatientBalance[], searchValue: string) => {
  if (!searchValue || !data) {
    return data ?? [];
  }

  const searchLower = searchValue.toLowerCase();
  return data.filter((patient) => {
    const fullName = `${patient.firstName} ${patient.lastName}`.toLowerCase();
    const patientId = patient.patientId ?? '';
    const phoneNumber = patient.phoneNumber ?? '';

    return fullName.includes(searchLower) || patientId.includes(searchLower) || phoneNumber.includes(searchLower);
  });
};

/**
 * Builds a filter string for the ListPatientBalances API request.
 * Combines balance type filters and search filters using wfilter syntax.
 */
export const getFilterString = (balanceType: BalanceType[], searchValue: string): string | undefined => {
  const balanceTypeMapping = {
    [BalanceType.BALANCE_TYPE_NEW]: 'NEW',
    [BalanceType.BALANCE_TYPE_UPDATE]: 'CHANGED',
    [BalanceType.BALANCE_TYPE_EXISTS]: 'EXISTING',
    [BalanceType.BALANCE_TYPE_UNKNOWN]: 'UNKNOWN',
  };

  const balanceTypeFilters = balanceType.map((bt) => `balance_type="${balanceTypeMapping[bt]}"`).join(' OR ');

  const escapeWfilter = (value: string) => value.replace(/["\\]/g, '\\$&');
  const searchFilter = searchValue ? `search("${escapeWfilter(searchValue)}")` : '';

  if (balanceTypeFilters && searchFilter) {
    return `(${balanceTypeFilters}) AND ${searchFilter}`;
  }

  return balanceTypeFilters || searchFilter || undefined;
};
